// extracted by mini-css-extract-plugin
export default {"greenToast":"toast_greenToast__fB0Rr","redToast":"toast_redToast__vCJaJ","yellowToast":"toast_yellowToast__lBpGk","toast":"toast_toast__2999-"};